/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import Lockr from "lockr";
import util from "@/lib/util";

import {apiGetModelList} from '@/api'
import {errorMessage} from '@/lib/msg'
import state from './state'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

Vue.use(Vuex);
let vue = new Vue();
export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
